import { PendingHourglass } from '../../../../../../../components/PendingHourglass/PendingHourglass';

export const PENDING_TRANSACTIONS_TOOLTIP =
  'This company has pending transactions impacting one or more metrics';

interface PendingTransactionsIndicatorProps {
  hasPendingTransactionImpact: boolean | undefined;
}

export function PendingTransactionsIndicator({
  hasPendingTransactionImpact,
}: PendingTransactionsIndicatorProps) {
  if (!hasPendingTransactionImpact) {
    return null;
  }

  return <PendingHourglass title={PENDING_TRANSACTIONS_TOOLTIP} ariaLabel='Pending transactions indicator' />;
}
